import { getWithAuth } from "./AxiosInterceptor";
import { getConfig } from '@edx/frontend-platform';

export function getUserDropDownData(page=1, name, status, sort) {
    const url = new URL(`${getConfig().LMS_BASE_URL}/dashboard_init`);
    url.searchParams.append('page', page);
    if (name) {
        url.searchParams.append('user', name);
        // return getWithAuth(`${getConfig().LMS_BASE_URL}/dashboard_init?page=${page}&user=${name}`);
    }
    if (status) {
        url.searchParams.append('status', status);
    }
    if (sort) {
        url.searchParams.append('sort', sort);
    }
    return getWithAuth(url.toString());
}
